import { Injectable } from '@angular/core';
import confetti from 'canvas-confetti';

@Injectable({
    providedIn: 'root',
})
export class ConfettiService {
    launchConfetti() {
        const duration = 10000;
        confetti({
            particleCount: 150,
            spread: 80,
            startVelocity: 45,
            origin: { y: 1 },
            zIndex: 9999
        });

        setTimeout(() => confetti.reset(), duration);
    }
}